import { render } from "./Footer.vue?vue&type=template&id=041e3202"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "041e3202"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('041e3202', script)) {
    api.reload('041e3202', script)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=041e3202", () => {
    api.rerender('041e3202', render)
  })

}

script.__file = "src/components/common/Footer.vue"

export default script